const pokemonList = [
  "ABRA",
  "AERODACTYL",
  "ALAKAZAM",
  "ALPHA",
  "ARBOK",
  "ARCANINE",
  "ARTICUNO",
  "BEEDRILL",
  "BELLOSSOM",
  "BELLSPROUT",
  "BLASTOISE",
  "BULBASAUR",
  "BUTTERFREE",
  "CATERPIE",
  "CHANSEY",
  "CHARIZARD",
  "CHARMANDER",
  "CHARMELEON",
  "CLEFABLE",
  "CLEFAIRY",
  "CLOYSTER",
  "CUBONE",
  "DEWGONG",
  "DIGLETT",
  "DITTO",
  "DODRIO",
  "DODUO",
  "DRAGONAIR",
  "DRAGONITE",
  "DRATINI",
  "DROWZEE",
  "DUGTRIO",
  "EEVEE",
  "EKANS",
  "ELECTABUZZ",
  "ELECTRODE",
  "EXEGGCUTE",
  "EXEGGUTOR",
  "FARFETCH",
  "FEAROW",
  "FLAREON",
  "GASTLY",
  "GENGAR",
  "GEODUDE",
  "GLOOM",
  "GOLBAT",
  "GOLDEEN",
  "GOLDUCK",
  "GOLEM",
  "GRAVELER",
  "GRIMER",
  "GROWLITHE",
  "GYARADOS",
  "HAUNTER",
  "HITMONCHAN",
  "HITMONLEE",
  "HORSEA",
  "HYPNO",
  "IVYSAUR",
  "JIGGLYPUFF",
  "JOLTEON",
  "JYNX",
  "KABUTO",
  "KABUTOPS",
  "KADABRA",
  "KAKUNA",
  "KANGASKHAN",
  "KINGLER",
  "KOFFING",
  "KRABBY",
  "LAPRAS",
  "LICKITUNG",
  "MACHAMP",
  "MACHOKE",
  "MACHOP",
  "MAGIKARP",
  "MAGMAR",
  "MAGNEMITE",
  "MAGNETON",
  "MANKEY",
  "MAROWAK",
  "MEGA",
  "MEOWTH",
  "METAPOD",
  "MEW",
  "MEWTWO",
  "MOLTRES",
  "MR",
  "MUK",
  "NIDOKING",
  "NIDOQUEEN",
  "NIDORINA",
  "NIDORINO",
  "NINETALES",
  "ODDISH",
  "OMANYTE",
  "OMASTAR",
  "ONIX",
  "PARAS",
  "PARASECT",
  "PERSIAN",
  "PIDGEOT",
  "PIDGEOTTO",
  "PIDGEY",
  "PIKACHU",
  "PINSIR",
  "POLITOED",
  "POLIWAG",
  "POLIWHIRL",
  "POLIWRATH",
  "PONYTA",
  "PORYGON",
  "PRIMEAPE",
  "PSYDUCK",
  "RAICHU",
  "RAPIDASH",
  "RATICATE",
  "RATTATA",
  "RHYDON",
  "RHYHORN",
  "SANDSHREW",
  "SANDSLASH",
  "SCYTHER",
  "SEADRA",
  "SEAKING",
  "SEEL",
  "SHELLDER",
  "SLOWBRO",
  "SLOWKING",
  "SLOWPOKE",
  "SNORLAX",
  "SPEAROW",
  "SQUIRTLE",
  "STARMIE",
  "STARYU",
  "TANGELA",
  "TAUROS",
  "TENTACOOL",
  "TENTACRUEL",
  "VAPOREON",
  "VENOMOTH",
  "VENONAT",
  "VENUSAUR",
  "VICTREEBEL",
  "VILEPLUME",
  "VOLTORB",
  "VULPIX",
  "WARTORTLE",
  "WEEDLE",
  "WEEPINBELL",
  "WEEZING",
  "WIGGLYTUFF",
  "ZAPDOS",
  "ZUBAT"
];

const alphabetLetters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
];

const baseUrl = process.env.PUBLIC_URL;

const images = {
  logo: `${baseUrl}/images/app-logo.png`,
  background: `${baseUrl}/images/background.png`,
  heart: `${baseUrl}/images/heart.png`,
  playing: `${baseUrl}/images/gottaCatchEmAll.png`,
  won: `${baseUrl}/images/happy-pikachu.png`,
  lost: `${baseUrl}/images/sad-pikachu.png`
};

export {
  pokemonList,
  alphabetLetters,
  images
};
